import { FC } from "react";

import { sendAIChatQuery } from "components/ai/queries/chat-query";
import { SECONDARY_OVERLAY_QUERY_PARAM, SecondaryOverlay } from "components/constants";
import { IconText } from "mds/components/IconText";
import { TrackedDiv } from "mds/components/TrackedDiv";
import { DoubleSparkleIcon } from "mds/icons";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectCurrentCourseId } from "store/selectors";
import { aiStateActions } from "store/slices/ai";
import { ComponentEventProperties } from "utils/amplitude";
import { useQueryParamsManager } from "utils/routing";

export type AIActionSuggestionProps = ComponentEventProperties & {
  fragment: string;
  fullText: string;
};

export const AIActionSuggestion: FC<AIActionSuggestionProps> = ({ fragment, fullText }) => {
  const { setQueryParams } = useQueryParamsManager();
  const dispatch = useAppDispatch();
  const courseId = useAppSelector(selectCurrentCourseId);

  const onClick = () => {
    // Ensure AI tab is open
    setQueryParams({ [SECONDARY_OVERLAY_QUERY_PARAM]: SecondaryOverlay.AIAssistant });
    dispatch(aiStateActions.clearAiChatMessages());
    sendAIChatQuery(dispatch, courseId, fullText);
  };

  return (
    <TrackedDiv
      className="mt-2 w-fit cursor-pointer rounded-lg border border-black-tint-90 bg-white py-1.5 pl-3 pr-2 text-sm text-black-tint-40"
      eventName="AI Action Suggestion"
      eventProps={{ message: fragment }}
      onClick={onClick}
    >
      <IconText iconEnd={<DoubleSparkleIcon />} text={fragment} />
    </TrackedDiv>
  );
};
